import { Form, useZodForm } from '@/components/Forms'
import { useModal } from '@/components/Modal'
import { Modal } from '@/ui/Modal'
import styles from './MechanicalInformationModal.module.scss'
import { LogInformation } from './components/LogInformation'
import { IssueDetails } from './components/IssueDetails'
import { EngineeringSolution } from './components/EngineeringSolution'
import { Actions } from './components/Actions'
import { schema } from '../schema'
import { Log } from '@/types/logs'
import { buildMechanicalInformationDefaultValues } from '../helpers/buildMechanicalInformationDefaultValues'
import { MechanicalInformationRequestBody } from '@/types/mechanicalInformation'
import { useSendMechanicalInformation } from '../api/useSendMechanicalInformation'
import { MechanicalInformationReadOnly } from './MechanicalInformationReadOnly'

type Props = {
    log: Log
    readOnly: boolean
    submitCallback?: (data: MechanicalInformationRequestBody) => void
}

export const MechanicalInformationModal = () => {
    const { props, closeModal } = useModal<Props>()

    const { handleSendMechanicalInformation, isPending } = useSendMechanicalInformation({
        log: props?.log,
        callback: props?.submitCallback,
    })

    const defaultValues = buildMechanicalInformationDefaultValues(props?.log)
    const form = useZodForm({
        schema,
        defaultValues,
    })

    if (!props?.log) {
        return null
    }

    return (
        <Modal className={styles.modal} onClose={closeModal}>
            <h1 className={styles.title}>Mechanical information</h1>
            <LogInformation log={props.log} />
            {props.readOnly && <MechanicalInformationReadOnly log={props.log} />}
            {!props.readOnly && (
                <Form form={form} className={styles.form} onSubmit={handleSendMechanicalInformation}>
                    <IssueDetails />
                    <EngineeringSolution />
                    <Actions isPending={isPending} />
                </Form>
            )}
        </Modal>
    )
}
